import { render, staticRenderFns } from "./ReportStockMovementsPage.vue?vue&type=template&id=3934a350&scoped=true"
import script from "./ReportStockMovementsPage.vue?vue&type=script&lang=js"
export * from "./ReportStockMovementsPage.vue?vue&type=script&lang=js"
import style0 from "./ReportStockMovementsPage.vue?vue&type=style&index=0&id=3934a350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3934a350",
  null
  
)

export default component.exports